import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

function generateInvoice(data) {
  const {
    invoiceNo,
    invoiceDate,
    customerName,
    customerAddress,
    customerContact,
    items,
    notes,
    discount = 0,
    tax = 0
  } = data;


  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-GY', {
      style: 'currency',
      currency: 'GYD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };
  

  const doc = new jsPDF();

  const img = new Image();
  img.src = `${process.env.PUBLIC_URL}/rcs-header.png`; // Make sure it's in /public

  img.onload = () => {
    // 🖼️ Insert header image (keep as-is since it looks perfect)
    doc.addImage(img, 'PNG', 10, 10, 190, 50);

    // ✅ Push content slightly lower to give breathing room
    let yStart = 70;

    // 🧾 Invoice Info
    doc.setFontSize(12);
    doc.text(`Invoice No: ${invoiceNo}`, 14, yStart);
    doc.text(`Invoice Date: ${invoiceDate}`, 14, yStart + 6);
    doc.text(`Customer: ${customerName}`, 14, yStart + 12);
    doc.text(`Address: ${customerAddress}`, 14, yStart + 18);
    doc.text(`Contact #: ${customerContact}`, 14, yStart + 24);

    // 📦 Items Table
    const tableRows = items.map((item, index) => [
      index + 1,
      item.description,
      item.quantity,
      formatCurrency(item.price), // ✅ formatted
      formatCurrency(item.quantity * item.price) // ✅ formatted
    ]);
    
    const tableHeaders = ['#', 'Description', 'Qty', 'Unit Price', 'Total'];

    autoTable(doc, {
      head: [tableHeaders],
      body: tableRows,
      startY: yStart + 30,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [42, 157, 143] },
    });

    // 💵 Totals
    const subtotal = items.reduce((acc, item) => acc + item.quantity * item.price, 0);
    const discountValue = (Number(discount) / 100) * subtotal;
    const taxValue = (Number(tax) / 100) * subtotal;
    const total = subtotal - discountValue + taxValue;
    
    const finalY = doc.lastAutoTable.finalY + 10;
    let currentY = finalY;
    const labelX = 130;
    const valueX = 180;
    const lineHeight = 8;
    
    doc.setFontSize(11);
    
    // Subtotal
    doc.setTextColor(0, 0, 0);
    doc.text('Subtotal:', labelX, currentY);
    doc.text(formatCurrency(subtotal), valueX, currentY, { align: 'right' });
    currentY += lineHeight;
    
    // Discount
    doc.setTextColor(100);
    doc.text(`Discount (${discount || 0}%):`, labelX, currentY);
    doc.text(`-${formatCurrency(discountValue)}`, valueX, currentY, { align: 'right' });
    currentY += lineHeight;
    
    // Tax
    doc.setTextColor(100);
    doc.text(`Tax (${tax || 0}%):`, labelX, currentY);
    doc.text(`+${formatCurrency(taxValue)}`, valueX, currentY, { align: 'right' });
    currentY += lineHeight;
    
    // Total with red box
    doc.setTextColor(200, 0, 0);
    doc.setFont('helvetica', 'bold');
    doc.rect(labelX, currentY - lineHeight + 2, 65, lineHeight + 2); // total box
    doc.text('TOTAL:', labelX + 2, currentY);
    doc.text(formatCurrency(total), valueX - 2, currentY, { align: 'right' });
    
    // Reset styles
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    
// After total is drawn
currentY += lineHeight + 4; // push below the total box

const defaultNote = [
  '* RCS reserves the right to impose penalties on outstanding amounts, at its discretion.',
  '* Kindly make all cheques payable in the company name.'
];


if (notes || defaultNote) {
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'normal');
  doc.text('Notes:', 14, currentY);

  const fullNote = [
    ...defaultNote,
    ...(notes ? ['', notes] : [])
  ];
  doc.text(fullNote, 14, currentY + 6);
  
  
}

    // 🦶 Footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(9);
    doc.text('Thank you for your business!', 105, pageHeight - 20, { align: 'center' });
    doc.text('RCS INVOICE GENERATOR © 2025', 105, pageHeight - 14, { align: 'center' });

    // 💾 Save
    doc.save(`Invoice_${invoiceNo || 'RCS'}.pdf`);
  };
}

export default generateInvoice;
